import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";

import TransparentCTAButton from "../components/widgets/transparentCtaButton/TransparentCTAButton";
import LinkCtaButton from "../components/widgets/linkCtaButton/LinkCTAButton";
import SolidCtaButton from "../components/widgets/solidCtaButton/SolidCtaButton";

import VideoModal from "../components/widgets/videoModal/VideoModal";
import ContentModal from "../components/widgets/contentModal/ContentModal";
import ImageModal from "../components/widgets/imageModal/ImageModal";

import ClickableImage from "../components/internal/clickableImage/ClickableImage";

const ModalHelper = ({ buttonProps, withClass }) => {
  const modal = buttonProps.modal[0];
  const intl = useIntl();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const Components = {
    link_cta: LinkCtaButton,
    linked_cta: LinkCtaButton,
    solid_cta: SolidCtaButton,
    transparent_cta: TransparentCTAButton,
    click_image: ClickableImage,
  };

  const ModalComponents = {
    video_modal: VideoModal,
    content_modal: ContentModal,
    image_modal: ImageModal,
  };
  let mclass = "content-modal";
  if (modal) {
    switch (modal.component) {
      case "video_modal":
        mclass = "video-modal";
        break;
      case "content_modal":
        mclass = "content-modal";
        break;
      case "image_modal":
        mclass = "image-modal";
        break;
      default:
        break;
    }

    let btnComponent = (
      <div className="button" onClick={handleShow}>
        <TransparentCTAButton buttonProps={buttonProps} withClass={withClass} />
      </div>
    );

    if (
      buttonProps.component &&
      typeof Components[buttonProps.component] !== "undefined"
    ) {
      // if (typeof Components[buttonProps.cta_type] !== "undefined") {
      // if(buttonProps.component === "click_image"){
      if (buttonProps.component === "click_image") {
        btnComponent = (
          <a
            className="btn image_button"
            href="javascript:void(0)"
            onClick={handleShow}
          >
            <ClickableImage image={buttonProps.image} buttonTheme={buttonProps.btnTheme || null} />
          </a>
        );
      } else {
        // const Component = Components[buttonProps.component];
        const Component = Components[buttonProps.component];
        // const Component = Components[buttonProps.cta_type];
        btnComponent = (
          <div className="button" onClick={handleShow}>
            <Component
              buttonProps={buttonProps}
              key={buttonProps._uid}
              withClass={withClass}
            />
          </div>
        );
      }
    } else if (
      buttonProps.cta_type &&
      typeof Components[buttonProps.cta_type] !== undefined
    ) {
      if (buttonProps.cta_type === "click_image") {
        btnComponent = (
          <a
            className="btn image_button"
            href="javascript:void(0)"
            onClick={handleShow}
          >
            <ClickableImage image={buttonProps.image} buttonTheme={buttonProps.btnTheme || null}/>
          </a>
        );
      } else {
        // const Component = Components[buttonProps.component];
        const Component = Components[buttonProps.cta_type];
        // const Component = Components[buttonProps.cta_type];
        btnComponent = (
          <div className="button" onClick={handleShow}>
            <Component
              buttonProps={buttonProps}
              key={buttonProps._uid}
              withClass={withClass}
            />
          </div>
        );
      }
    }else if (buttonProps.triggerText){
      btnComponent = (
        <a className="modal-trigger-link" onClick={handleShow}>
          {buttonProps.triggerText}
        </a>
      )
    }

    let modalBlock = <ContentModal props={modal} />;

    if (typeof ModalComponents[modal.component] !== "undefined") {
      const ModalComponent = ModalComponents[modal.component];
      modalBlock = <ModalComponent blok={modal} />;
    }

    return (
      <>
        {btnComponent}
        {modal ? (
          <Modal
            className={mclass}
            //   className="content-modal"
            // {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
          >
            <Modal.Header>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              >
                {intl.messages["widget.modal.exit"]}
              </button>
            </Modal.Header>
            {modalBlock}
          </Modal>
        ) : (
          <h1>No Modal</h1>
        )}
      </>
    );
  }
  return null;
};

export default ModalHelper;
